import { ofType, combineEpics } from 'redux-observable';
import { of, from, EMPTY } from 'rxjs';
import {
  switchMap, mergeMap, catchError, ignoreElements,
} from 'rxjs/operators';

import { handleError } from '@ezugi/utils/http/httpErrors';

import { CLEAR_AUTH_PARAMS } from '../../../endpoints';
import { app } from '../../app';
import { config } from '../../config';
import { locale } from '../../locale';
import { user } from '../../user';
import { getUser } from './getUser';

const userEpic = (action$) => action$.pipe(
  ofType(user.request),
  switchMap(() => {
    const urlParams = new URLSearchParams(window?.location?.search);
    const params = new URLSearchParams();

    [ 'token', 'operatorId', 'identifier' ].forEach((key) => {
      if (urlParams.has(key)) {
        params.set(key, urlParams.get(key));
      }
    });

    return from(getUser(params)).pipe(

      mergeMap(({ result }) => of(config.request(result))),
    );
  }),
  catchError((error) => handleError({
    error,
    failAction: app.update,
    options: {
      payloadKey: 'error',
      httpErrorHandler: (err) => (err.response?.locale ? of(
        locale.set(err.response?.locale),
        config.update({ ...error.response.initialConfig }),
        user.failure()
      ) : EMPTY),
      clientErrorHandler: () => of(user.failure()),
    },
  }))
);

const clearSelectGameEpic = (action$, state$) => action$.pipe(
  ofType(user.clearSelectGame),
  switchMap(() => from(
    fetch(
      `${CLEAR_AUTH_PARAMS}?${
        new URLSearchParams({
          identifier: state$.value.user.identifier,
          auth_param_key: 'selectGame',
        })}`,
      {
        credentials: 'include',
      },
      // eslint-disable-next-line no-console
    ).catch((err) => console.error(`Failed to clear auth param: ${err}`),),
  )),
  // eslint-disable-next-line no-console
  catchError(console.error),
  ignoreElements()
);

export default combineEpics(userEpic, clearSelectGameEpic);
